module.exports = __webpack_public_path__ + "assets/img/Telegram.f0700bd9.svg";